import { getApp } from 'firebase/app'
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check'
import rg4js from 'raygun4js'
import { lazy, Suspense, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import PageLoading from '../../components/PageLoading'
import config from '../../config'

const NotFound = lazy(() => import('../../components/NotFound'))
const Layout = lazy(() => import('./components/Layout'))
const ForgotPassword = lazy(() => import('./ForgotPassword'))
const RecoverAccount = lazy(() => import('./RecoverAccount'))
const EmailAction = lazy(() => import('./EmailAction'))
const Login = lazy(() => import('./Login'))
const LoginWithEmailLink = lazy(() => import('./LoginWithEmailLink'))
const Register = lazy(() => import('./Register'))
const ResetPassword = lazy(() => import('./ResetPassword'))
const Verify = lazy(() => import('./Verify'))
const ConfirmationEmail = lazy(() => import('./ConfirmationEmail'))
const NoAccountIdp = lazy(() => import('./NoAccountIdp'))
const Logout = lazy(() => import('./Logout'))

/**
 * Renders Layout with lower level routes
 */

export default function Router() {
  const location = useLocation()

  useEffect(() => {
    const app = getApp()
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(config.captcha.recaptcha.key),
      isTokenAutoRefreshEnabled: true
    })
  }, [])

  useEffect(() => {
    /* Track a page view */
    rg4js('trackEvent', {
      type: 'pageView',
      path: location.pathname
    })
  }, [location])

  return (
    <Layout>
      <Suspense fallback={<PageLoading />}>
        <Routes>
          <Route path="verify" element={<Verify />} />
          <Route path="login" element={<Login />} />
          <Route path="logout" element={<Logout />} />
          <Route path="switch-account" element={<Logout />} />
          <Route path="login-email" element={<LoginWithEmailLink />} />
          <Route path="email-action" element={<EmailAction />} />
          <Route path="register" element={<Register />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="recover-account" element={<RecoverAccount />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="no-account-idp" element={<NoAccountIdp />} />
          <Route path="confirmation" element={<ConfirmationEmail />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Layout>
  )
}
